export default "__VITE_PUBLIC_ASSET__a4f9ff45__"